import React, { Component } from 'react';
import { connect } from 'react-redux';
import linkState from '../../utils/react-link-state';
import CommentEditor from '../Helpers/Editors/CommentEditor.jsx';
import axios from 'axios';
import { observer,inject } from "mobx-react";
import { observable, makeObservable, toJS } from "mobx";

import Image from "./AttachmentsEdit/Image";
import Embed from "./AttachmentsEdit/Embed";
import Gallery from "./AttachmentsEdit/Gallery";
import TenorGif from "./AttachmentsEdit/TenorGif";
import CommentItem from "./CommentItem";
import {custom} from "../../utils/linker";
import generateUid from "../../utils/generateUid";
import Tooltip from "../Helpers/Tooltip";
import MyPhotos from "./AttachmentsEdit/MyPhotos";

class CommentsForm extends Component {
  attachments=[];
  show_attachments=false;
  comment='';
  posting=false;

  constructor(props) {
    super(props);

    makeObservable(this,{
      attachments: observable,
      show_attachments: observable,
      posting: observable,
      comment: observable,
    })

    this.state={
      comment:''
    };
  }
  submitComment() {
    if(this.posting) {
      return false;
    }
    if(this.comment || this.attachments) {
      this.posting=true;
      var form=new FormData();

      form.append('text', toJS(this.comment));

      let vars={text: toJS(this.comment)};
      if(this.props.commentsStore.reply_to._id && this.props.commentsStore.reply_to._id!==-1) {
        vars.parent_id=this.props.commentsStore.reply_to._id;
        form.append('parent_id', this.props.commentsStore.reply_to._id);
      }

      const attachments=toJS(this.attachments);
      console.log('typeof attachments[i].image ATTACH', attachments);
      const files=[];
      for(let i in attachments) {
        if(attachments[i].show_spoiler) {
          delete attachments[i].show_spoiler;
        }
        if(attachments[i].type == "image") {
          if(attachments[i].uploaded) {
            form.append(`${i}:image`, attachments[i].uploaded);
            attachments[i].uploaded = `${i}:image`;
            // delete attachments[i].uploaded
          }
        }
        if(attachments[i].type == "gallery") {
          for(let j in attachments[i].gallery) {
            if(attachments[i].gallery[j].uploaded) {
              form.append(`${i}:gallery:${j}`, attachments[i].gallery[j].uploaded);
              attachments[i].gallery[j].uploaded=`${i}:gallery:${j}`;
            }
          }
        }
      }
      form.append("attachments",JSON.stringify(attachments));
      // console.log('JSON',toJS(this.attachments));
      // const form=new FormData();
      // form.append('')

      // return false;

      if(this.props.edit_linker) {
        axios.post(`/api/comments/edit/${this.props.edit_linker.value._id}`, form).then((item) => {
          console.log('EDIT_ANSWER',item.data);
          if(item.data.answer) {
            this.props.edit_linker.value = item.data.answer;
            this.props.onCancelEdit(true);
          }
          this.posting=false;
        });
      } else {
        let url='';
        if(this.props.commentsStore.category && this.props.commentsStore.element) {
          url=`/api/comments/${this.props.commentsStore.category}/${this.props.commentsStore.element}`;
        } else {
          if(this.props.commentsStore.reply_to._id) {
            url=`/api/comments/${this.props.commentsStore.reply_to.category_id}/${this.props.commentsStore.reply_to.element_id}`;
          }
        }
        if(!url) {
          return false;
        }
        axios.post(url, form).then((item) => {
          if (item.data.answer) {
            this.comment = '';
            this.attachments = [];
            this.props.commentsStore.replyTo({_id: 0});
            this.props.commentsStore.commentPosted(item.data.answer);
            if(this.props.onCommentPost) {
              this.props.onCommentPost(item.data.answer);
            }
          } else {
            this.props.appStateStore.pushGlobalErrors(item.data.errors);
          }
          this.posting=false;
          /*this.props.onSubmit();*/
        });
      }
    }
  }
  getReplyTo() {
    if(this.props.commentsStore.reply_to._id === 0) {
      return null;
    }
    if(this.props.commentsStore.reply_to._id === -1) {
      return null;
    }
    if(this.props.commentsStore.reply_to.user && !this.props.edit_linker) {
      return (
        <div>
          <span className="fs13 hpadd5 bg-const3 dib">
            {this.props.translateStore.t.lk.reply_to} {this.props.commentsStore.reply_to.user.nick}
          </span>
        </div>
      )
    }
  }
  componentDidMount() {
    if(this.props.edit_linker) {
      this.comment=this.props.edit_linker.value.text;
      this.attachments=this.props.edit_linker.value.attachments;

      // this.props.edit_linker.value.text
    }
  }

  renderAttachments() {
    return (
      <div className={`${this.attachments.length>0?'hpadd10 ptop10':''}`}>
        {this.attachments.map((cur,index)=>{
          let Comp;
          switch(cur.type) {
            case "image":
              Comp=Image;
              break;
            case "embed":
              Comp=Embed;
              break;
            case "gallery":
              Comp=Gallery;
              break;
            case "myphotos":
              Comp=MyPhotos;
              break;
            case "tenorgif":
              Comp=TenorGif;
              break;
          }
          return <Comp isOwner={!this.props.edit_linker || this.props.meStore.me.data.id == this.props.edit_linker.value.user.id} key={cur.id} {...custom(this.attachments,index)} deleteMe={()=>{ this.attachments.splice(index,1); }} />
        })}
      </div>
    )
  }
  showLoginForm() {
    if(typeof window.showLoginForm !== "undefined") {
      window.showLoginForm();
    }

  }
  isSmall() {
    return this.props.commentsStore.small_mode;
  }
  render() {
    if(this.props.commentsStore.readonly) {
      return (
        <div className="padd20 bg-w2-op50 rad4 tac s-mbottom5 m-mbottom10">
          Форма комментирования отключена.
        </div>
      )
    }
    if(!this.props.meStore.me.data) {
      return (
        <div className="padd20 bg-w2-op50 rad4 tac s-mbottom5 m-mbottom10">
          {this.props.translateStore.t.lk.need_auth_to_post_comment}
          <div className="ptop10 up12 margin s-center">
            <div className="cell s-shrink s-middle">
              <a href="/register/">{this.props.translateStore.t.lk.sign_up}</a>
            </div>
            <div className="cell s-shrink s-middle">
              <div className="btn1" onClick={()=>{ this.showLoginForm(); }}><span>{this.props.translateStore.t.lk.sign_in}</span></div>
            </div>

          </div>
        </div>
      )
    }
    /*return (
        <div className="boxShadow bo-w1 solid1 bg-w1 mbottom20">
          <div className="padd20">
            Форма комментирования в настоящий момент закрыта.
          </div>
        </div>
    );*/
    return (
      <div className="boxShadow bg-w1 mbottom20">
        <div className="up12 splice">
          <div className="cell s-shrink">
            <img src={`${this.props.edit_linker?this.props.edit_linker.value.user.avatar:this.props.meStore.me.data.avatar}`} className="db rad4 mleft5 mtop5" style={{ width:40 }}/>
          </div>
          <div className="cell s-auto s-middle">
            <div className="pleft10">
              <strong>{this.props.edit_linker?this.props.edit_linker.value.user.nick:this.props.meStore.me.data.nick}</strong>
              {this.getReplyTo()}
            </div>
          </div>
        </div>

        <CommentEditor onCtrlEnter={()=>{ this.submitComment(); }} small={this.isSmall()} autofocus={this.props.commentsStore.reply_to._id} onFilePaste={(file)=>{
          if(this.attachments.length != 1 || this.attachments[0].type != "gallery") {
            this.attachments= [ { type:"gallery", id:generateUid(), gallery:[ { uploaded:file } ]} ];
          } else {
            this.attachments[0].gallery.push({ uploaded:file });
          }

        }} {...custom(this,'comment')} valueLink={linkState(this,'comment')} />
        {this.renderAttachments()}

        <div className="up12 splice">
          <div className="cell s-auto s-middle">
            {this.attachments.length>0 || this.isSmall()?null:(
              <>
                {/*
                <Tooltip text={this.props.translateStore.t.lk.attach_add_photo}>
                  <span className="pointer dib padd5" onClick={()=>{ this.attachments.push({ type:"image", id:generateUid() }); }}>
                    <span className="span fs24 mdi mdi-image-outline pc1-op50 pc1-hover"></span>
                  </span>
                </Tooltip>
                */}
                <Tooltip text={this.props.translateStore.t.lk.attach_add_gallery}>
                  <span className="pointer dib padd5" onClick={()=>{ this.attachments.push({ type:"gallery", id:generateUid() }); }}>
                    <span className="span fs24 mdi mdi-image-multiple pc1-op50 pc1-hover"></span>
                  </span>
                </Tooltip>
                <Tooltip text={this.props.translateStore.t.lk.attach_add_embed}>
                  <span className="pointer dib padd5" onClick={()=>{ this.attachments.push({ type:"embed", id:generateUid() }); }}>
                    <span className="span fs24 mdi mdi-iframe-outline pc1-op50 pc1-hover"></span>
                  </span>
                </Tooltip>
                <Tooltip text={this.props.translateStore.t.lk.attach_myphotos}>
                  <span className="pointer dib padd5" onClick={()=>{ this.attachments.push({ type:"myphotos", id:generateUid() }); }}>
                    <span className="span fs24 mdi mdi-image-area-close pc1-op50 pc1-hover"></span>
                  </span>
                </Tooltip>
                <Tooltip text={this.props.translateStore.t.lk.attach_gif}>
                  <span className="pointer dib padd5" onClick={()=>{ this.attachments.push({ type:"tenorgif", id:generateUid() }); }}>
                    <span className="span fs24 mdi mdi-gif pc1-op50 pc1-hover"></span>
                  </span>
                </Tooltip>
              </>
            )}
          </div>
          <div className="cell s-shrink s-bottom pright10 pbottom10">
            {this.props.edit_linker?(
              <span onClick={()=>{ this.props.onCancelEdit(); }} className="btn2 mright10"><span>{this.props.translateStore.t.lk.cancel}</span></span>
            ):null}
            <span onClick={()=>{ this.submitComment(); }} className={`btn1 ${this.posting?'btnLoading':''} ${this.isSmall()?"small":""}`}><span>{this.props.translateStore.t.lk.submit}</span></span>
          </div>
        </div>
        <div className="tar">

        </div>

      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    me:state.me
  }
}


export default inject("meStore","commentsStore","appStateStore","translateStore")(observer(CommentsForm));